import { Injectable } from "@angular/core";
import { Converter, Occ, ProductSearchPage, ConverterService, PRODUCT_NORMALIZER, Facet } from "@spartacus/core";
import { KB_PRODUCT_URL_NORMALIZER } from "src/app/app.module";


@Injectable({ providedIn: 'root' })
export class kbOccProductSearchPageNormalizer
    implements Converter<Occ.ProductSearchPage, ProductSearchPage>
{
    constructor(private converterService: ConverterService) { }

    protected DEFAULT_TOP_VALUES = 6;

    convert(
        source: Occ.ProductSearchPage,
        target: ProductSearchPage = {}
    ): ProductSearchPage {
        target = {
            ...target,
            ...(source as any),
        };

        this.normalizeFacets(target);
        if (source.products) {
            target.products = source.products.map((product) =>
            this.converterService.convert(product, PRODUCT_NORMALIZER),
            ).map((x) =>
                this.converterService.convert(x, KB_PRODUCT_URL_NORMALIZER),
            );
        }
        return target;
    }

    protected normalizeFacets(target: ProductSearchPage): void {
        this.normalizeFacetValues(target);
        this.normalizeUselessFacets(target);
    }
    //as of now in line no 47 I am making this changes as by client requests to show facets even for single product
    //but spartacus wants to remove this in feature in future from backend
    //so requires some changes if sap changed it in future
    protected normalizeUselessFacets(target: ProductSearchPage): void {
        if (target.facets) {
            target.facets = target.facets.filter((facet) => {
                return (
                    !target.pagination ||
                    !target.pagination.totalResults ||
                    ((!facet.hasOwnProperty('visible') || facet.visible) &&
                        facet.values &&
                        facet.values.find((value) => {
                            return (
                                value.selected ||
                                (value.count ?? 0) <= (target.pagination?.totalResults ?? 0)
                            );
                        }))
                );
            });
        }
    }

    protected normalizeFacetValues(target: ProductSearchPage): void {
        if (target.facets) {
            target.facets = target.facets.map((facetSource: Facet) => {
                const { topValues, ...facetTarget } = facetSource;
                facetTarget.topValueCount =
                    topValues && topValues.length > 0
                        ? topValues.length
                        : this.DEFAULT_TOP_VALUES;
                return facetTarget;
            });
        }
    }
}
